import { Component, computed, inject, signal, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { UploadService, UploadTask } from '../../../core/services/upload.service';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-global-upload-progress',
    standalone: true,
    imports: [CommonModule, TranslateModule, ButtonModule, ProgressBarModule],
    templateUrl: './global-upload-progress.component.html',
    styleUrls: ['./global-upload-progress.component.scss']
})
export class GlobalUploadProgressComponent {
    private readonly uploadService = inject(UploadService);
    private readonly router = inject(Router);

    isMinimized = signal(true);
    currentUrl = signal(this.router.url);

    uploadTasks = this.uploadService.uploads;
    hasUploads = computed(() => this.uploadTasks().size > 0);

    // Path pattern for "Quản lý bài học": /courses/.../sections/.../videos
    isTargetPage = computed(() => {
        const url = this.currentUrl();
        return url.includes('/sections/') && url.includes('/videos');
    });

    shouldShow = computed(() => this.hasUploads() && !this.isTargetPage());

    constructor() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntilDestroyed()
        ).subscribe((event: any) => {
            this.currentUrl.set(event.urlAfterRedirects || event.url);
        });
    }

    toggleMinimize(): void {
        this.isMinimized.update(v => !v);
    }

    navigateToSection(task: UploadTask): void {
        this.router.navigate(['/courses', task.courseId, 'sections', task.sectionId, 'videos']);
    }
}
